import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";

export interface IBinFormMeta {
    minRange: FormInputMeta;
    maxRange: FormInputMeta;
    networkCardType: FormInputMeta;
    productType: FormInputMeta;
    panGenerationAlgorithm: FormInputMeta;
    pvkiSelectionAlgorithm: FormInputMeta;
    binWidth: FormInputMeta;
    binSequence: FormInputMeta;
    cardWidth: FormInputMeta;
    pinWidth: FormInputMeta;
    status: FormInputMeta;
    binType: FormInputMeta;
    //
    schema: any;
  }

const BinFormMeta = {} as IBinFormMeta;

BinFormMeta.minRange = {
  name: 'minRange',
  type: 'text',
  label: 'Min. Range',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.maxRange = {
  name: 'maxRange',
  type: 'text',
  label: 'Max. Range',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.networkCardType = {
  name: "networkCardType",
  label: "Type carte réseau",
  type: "select",
  options:  [],
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.productType = {
  name: "productType",
  label: "Type produit",
  type: "select",
  options:  [],
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.panGenerationAlgorithm = {
  name: "panGenerationAlgorithm",
  label: "Algorithme Generation PAN",
  type: "select",
  options:  [],
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.pvkiSelectionAlgorithm = {
  name: "pvkiSelectionAlgorithm",
  label: "Algorithme Selection Pvki",
  type: "select",
  options:  [],
  validation: yup.string().required("Ce champ est requis"),
};
//
BinFormMeta.binWidth = {
  name: 'binWidth',
  type: 'number',
  label: 'Longueur Bin',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.binSequence = {
  name: 'binSequence',
  type: 'number',
  label: 'Sequence Bin',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.cardWidth = {
  name: 'cardWidth',
  type: 'number',
  label: 'Longueur carte',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.pinWidth = {
  name: 'pinWidth',
  type: 'number',
  label: 'Longueur Pin',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.status = {
  name: "status",
  label: "Statut",
  type: "select",
  options:  [],
  validation: yup.string().required("Ce champ est requis"),
};
BinFormMeta.binType = {
  name: "binType",
  label: "Type Bin",
  type: "select",
  options:  [],
  validation: yup.string().required("Ce champ est requis"),
};

BinFormMeta.schema = yup.object().shape(getValidationSchema(BinFormMeta));

export default BinFormMeta;